import { render, staticRenderFns } from "./UnsubscribeNotificationView.vue?vue&type=template&id=1adba219&"
import script from "./UnsubscribeNotificationView.vue?vue&type=script&lang=js&"
export * from "./UnsubscribeNotificationView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports